import { formatter, request } from '@/utils/request';

export namespace SoldToReal {
  export const Path = {
    Get: '/expenseapi/soldToReal/get',
    Search: '/expenseapi/soldToReal/search',
    AjaxSearch: '/expenseapi/soldToReal/ajaxSearch',
    SearchForSp: '/expenseapi/soldToReal/searchForSp',
    Query: '/expenseapi/soldToReal/query',
    Export: '/expenseapi/soldToReal/export',
    Post: '/expenseapi/soldToReal/post',
    QueryForSelect: '/expenseapi/soldToReal/queryForSelect',
  };

  export async function get(id: string) {
    const options = {
      method: 'GET',
      body: {
        code: id,
      },
    };
    return request<API.ResponseResult<API.SoldToReal>>(Path.Get, formatter(options));
  }

  export async function queryForSelect(body: API.QueryForPageReq) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.QueryResult<any>>(Path.QueryForSelect, formatter(options));
  }

  export async function search(body: API.SoldToRealSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<API.SoldToReal[]>>(Path.Search, formatter(options));
  }

  export async function ajaxSearch(body: API.SoldToRealSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<API.SoldToReal[]>>(Path.AjaxSearch, formatter(options));
  }

  export async function query(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.QueryResult<any[]>>(Path.Query, formatter(options));
  }

  export async function exportEx(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<any[]>>(Path.Export, formatter(options));
  }
}
